import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedEditionDndaWorkflowStateListStore } from "../../store/SignedEditionDndaWorkflowStateListStore";
import { SignedEditionDndaWorkflowStateListForm } from "./SignedEditionDndaWorkflowStateListForm";
import { SignedEditionDndaWorkflowStateListDialogs } from "./SignedEditionDndaWorkflowStateListDialogs";
import { ListToolbox } from "../../../../common/controls";
import { useStore } from "../../../../hooks";

export const SignedEditionDndaWorkflowStateListPage = observer(() => {
  const rootStore = useRootStore();
  const { langStore } = rootStore;
  const path = "/signedEditionDndaWorkflowState/list";

  const store = useStore(
    path,
    () => new SignedEditionDndaWorkflowStateListStore(rootStore)
  );

  const cancelProcess: (() => void) | undefined = undefined;

  const listToolbox = (
    <ListToolbox
      paginatorProps={{
        page: store.currentPage,
        totalRows: store.totalRows,
        rowsPerPage: store.pageSize,
        hasNextPage: store.hasNextPage,
        onPageChange: (newPage: number) => store.onPageChange(newPage),
        onPageSizeChange: (pageSize: number) =>
          store.onPageSizeChange(pageSize),
      }}
      createNewElement={
        store.isActionEnabled("create")
          ? (event) => store.createNewSignedEditionDndaWorkflowState(event)
          : undefined
      }
      createNewLabel={`${langStore.newCommand}`}
      createNewLabelTooltip={`${langStore.addCommand} undefined`}
      processing={store.status === "fetching" || store.status === "processing"}
      cancelProcess={cancelProcess}
      showColumnFilters={store.grid.showColumnFilters}
      onToggleFilters={() => store.grid.toggleShowColumnFilters()}
      filtersLabel={`${langStore.filtersCommand}`}
      isFullScreen={store.grid.isFullScreen}
      onToggleFullScreen={() => store.grid.toggleIsFullScreen()}
      viewMode={store.grid.viewMode}
      onToggleViewMode={() => {
        store.grid.toggleViewMode();
        store.saveProfile();
      }}
      columnsLabel={`${langStore.columnsCommand}`}
      columns={store.grid.columnMenuItems}
      columnVisibility={store.grid.mrtColumnVisibility}
      onColumnVisibilityChange={(visibility) =>
        store.grid.setMrtColumnVisibility(visibility)
      }
      columnOrder={store.grid.columnOrder}
      onColumnOrderChange={(order) => store.grid.setColumnOrder(order)}
      onResetColumnOrder={() => store.grid.resetColumnOrder()}
      onShowAllColumns={() => store.grid.showAllColumns()}
      onHideAllColumns={() => store.grid.hideAllColumns()}
      onSaveFormat={() => store.saveProfile()}
      language={langStore.language as "es" | "en" | "pt"}
    />
  );

  return (
    <div>
      <PageLayout secondaryToolbox={listToolbox}>
        <SignedEditionDndaWorkflowStateListForm listStore={store} />
      </PageLayout>
      <SignedEditionDndaWorkflowStateListDialogs store={store} />
    </div>
  );
});
